import { useTranslation } from 'react-i18next';
import {
  Accordion,
  GoogleFontIcon,
  MainNavigation,
  Tooltip,
} from '@asset-metrix/portal-ui';
import clsx from 'clsx';

import { useStore } from '../../store';

import { useNavigationContext } from './NavigationContext';

import styles from './detailsPageNavSection.module.scss';

const DETAIL_PAGES_NAV_ACCORDION_VALUE = 'detail-pages';

const AccordionAction = () => {
  const { t } = useTranslation();
  const { handleCloseAll } = useNavigationContext();

  return (
    <span className={styles['accordion-header-action']}>
      <Tooltip
        position="right"
        label={t('app.navigation.dynamicNavSection.closeAll')}
      >
        <GoogleFontIcon
          data-testid="close-all"
          onClick={(e) => {
            e.stopPropagation();
            handleCloseAll();
          }}
          solid
          small
          name="close"
        />
      </Tooltip>
    </span>
  );
};

export const DetailsPageNavSection = () => {
  const { t } = useTranslation();
  const {
    activeDynamicNavigationItemIndex,
    dynamicNavItems,
    handleClick,
    handleClose,
    isPending: isNavigationPending,
  } = useNavigationContext();

  const collapsed = useStore((state) => state.isNavigationCollapsed);

  if (!dynamicNavItems || dynamicNavItems.length === 0) {
    return null;
  }

  const title = t('app.navigation.dynamicNavSection.title');
  const accordionTitle = !collapsed ? title : '';

  return (
    <div className={styles['seperator']}>
      <Accordion
        chevronPosition="left"
        itemValue={DETAIL_PAGES_NAV_ACCORDION_VALUE}
        defaultValue={DETAIL_PAGES_NAV_ACCORDION_VALUE}
        classNames={{
          root: styles['accordion-root'],
          content: styles['accordion-content'],
          chevron: styles['accordion-chevron'],
        }}
      >
        <Accordion.Header
          data-testid="details-page-accordion"
          className={clsx(
            styles['accordion-header'],
            collapsed && styles['accordion-collapsed']
          )}
          actions={!collapsed ? <AccordionAction /> : undefined}
        >
          <span className={styles['accordion-header-label']}>
            {accordionTitle}
          </span>
        </Accordion.Header>
        <Accordion.Body>
          <MainNavigation
            activeItemIndex={activeDynamicNavigationItemIndex}
            collapsed={collapsed}
            items={dynamicNavItems}
            isDetailsPageSection
            onClick={handleClick}
            onClose={handleClose}
            isPending={isNavigationPending}
          />
        </Accordion.Body>
      </Accordion>
    </div>
  );
};
